import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MakeHash from 'make-hash';
import RadioOption from 'components/fields/radios/radio-option';

export default class RadioGroup extends React.Component {
  constructor(props) {
    super();

    this.state = { 'activeOption': props.activeOption };

    this.setUpHandlers();
  }

  /**
   * React Lifecycle Hook
   * Invoked before a mounted component receives new props. If you need to
   * update the state in response to prop changes, you may compare this.props
   * and nextProps and perform state transitions
   *
   * @method  componentWillReceiveProps
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.activeOption !== this.props.activeOption) {
      this.setState({ 'activeOption': nextProps.activeOption });
    }
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.changeActiveOption = this.changeActiveOption.bind(this);
  }

  /**
   * Changes the active button within a button group
   *
   * @method  changeActiveOption
   * @param  {Object} option [option index to set to active]
   */
  changeActiveOption(option, index) {
    const { onChange } = this.props;

    if (onChange) {
      onChange(option);
    } else {
      this.setState({ 'activeOption': index });
    }
  }

  render() {
    const { options, className, activeOption } = this.props;
    const groupClasses = classNames(
      'radioGroup',
      className
    );

    return (
      <div className={groupClasses}>
        {options.map((option, i) => {
          return (
            <RadioOption
              key={MakeHash(`radioGroup-btn-${i}`)}
              changeActiveOption={() => this.changeActiveOption(option, i)}
              buttonTxt={option.description}
              index={i}
              isActive={i === this.state.activeOption}
              theme="dark"
            />
          );
        })}
      </div>
    );
  }
}

const optionShape = PropTypes.shape({
  'description': PropTypes.string.isRequired
});

RadioGroup.propTypes = {
  'activeOption': PropTypes.number,
  'onChange': PropTypes.func,
  'options': PropTypes.arrayOf(optionShape),
};

RadioGroup.defaultProps = {
  'activeOption': 0
}



// WEBPACK FOOTER //
// ./src/client/components/fields/radios/radio-group.jsx